var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.912,
    height: 24.67,
    viewBox: "0 0 18.912 24.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7075",
    "data-name": "Group 7075",
    transform: "translate(-8.498 -0.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7077",
    "data-name": "Group 7077",
    transform: "translate(8.498 0.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7075-2",
    "data-name": "Group 7075",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18960",
    "data-name": "Path 18960",
    d: "M25.06,9.4a.709.709,0,1,1-1.117.231c.963-1.579,3.389-3.852,3.466-5.354A2.175,2.175,0,0,0,24.483,2.2c-.039-.385.193-1.233-.385-1.233-.693,0-1.387,0-2,.039V5.4a.4.4,0,0,1-.193.347.35.35,0,0,1-.385,0L20.708,5.2l-.847.5a.35.35,0,0,1-.385,0,.4.4,0,0,1-.193-.347V1.006c-7.472,0-7.9-.27-7.9.347V2.2A2.135,2.135,0,0,0,8.5,4.28,4.033,4.033,0,0,0,9.5,6.4c2.311,3,2.311,3,2.426,3.158A.709.709,0,1,1,10.848,9.4a.372.372,0,0,0,0-.539c-.424-.424-1,.347-1,1a1.486,1.486,0,0,0,2.85.616,12.5,12.5,0,0,0,3.351,4.237.907.907,0,0,1-.616,1.579,1.121,1.121,0,0,0-1.078.809h7.241a1.268,1.268,0,0,0-.27-.5,1.049,1.049,0,0,0-.809-.347.9.9,0,0,1-.655-.27.886.886,0,0,1,.039-1.31l.5-.462A12.062,12.062,0,0,0,23.25,10.4a1.487,1.487,0,0,0,2.85-.616,1.527,1.527,0,0,0-.462-1.04C25.215,8.478,24.675,9.056,25.06,9.4Zm-.578-6.355A1.375,1.375,0,0,1,26.6,4.242c-.039.809-.655,1.387-2.5,3.813A18.906,18.906,0,0,0,24.483,3.048ZM9.269,4.242a1.364,1.364,0,0,1,2.118-1.194,18.907,18.907,0,0,0,.385,5.007C10,5.744,9.308,5.089,9.269,4.242Z",
    transform: "translate(-8.498 -0.948)",
    fill: "#ffc935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18961",
    "data-name": "Path 18961",
    d: "M39.771,4.8V1.1H38.5V4.759l.424-.27C39.232,4.3,39.5,4.643,39.771,4.8Z",
    transform: "translate(-26.945 -1.041)",
    fill: "#ff0009"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7076",
    "data-name": "Group 7076",
    transform: "translate(4.276 16.967)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4021",
    "data-name": "Rectangle 4021",
    width: 6.008,
    height: 1.233,
    transform: "translate(2.157 1.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18962",
    "data-name": "Path 18962",
    d: "M29.19,45H20.332a.731.731,0,0,0-.732.732v3.62H29.884v-3.62A.678.678,0,0,0,29.19,45Zm-.655,3.351a.364.364,0,0,1-.385.385H21.372a.364.364,0,0,1-.385-.385v-2a.364.364,0,0,1,.385-.385H28.15a.364.364,0,0,1,.385.385v2Z",
    transform: "translate(-19.6 -45)",
    fill: "#ffc935"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7078",
    "data-name": "Group 7078",
    transform: "translate(10.27 23.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18963",
    "data-name": "Path 18963",
    d: "M28.429,60.5a.414.414,0,0,1-.385.385H13.485A.414.414,0,0,1,13.1,60.5a.386.386,0,0,1,.385-.385h.732V58.685A.364.364,0,0,1,14.6,58.3H26.927a.364.364,0,0,1,.385.385V60.11h.732A.386.386,0,0,1,28.429,60.5Z",
    transform: "translate(-13.1 -58.3)",
    fill: "#ffc935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.144a6369111c756b84aa0f0c3fdf661c.svg";
export { ForwardRef as ReactComponent };